﻿
import HTMLRenderer from './html';

class SVGRenderer extends HTMLRenderer{

    constructor(){
        super();
    }


    createNode(ctrl, blueprint){
        //super.createNode(ctrl, blueprint);
        let renderOutput = ctrl.renderOutput || {};        

        let node = false;

        switch (ctrl.type){
            case 'group':
                node = document.createElementNS('http://www.w3.org/2000/svg', 'g');
                break;
            case 'path':
                node = document.createElementNS('http://www.w3.org/2000/svg', 'path');
                break;
            case 'arc':
                node = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
                break;
            case 'rect':
                node = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
                break;
            case 'textbox':
                node = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                break;
            case 'svg':
                node = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                break;
            case 'defs':
                node = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
                break;
            case 'linearGradient':
                node = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
                break;
            case 'stop':
                node = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
                break;
            case 'clipPath':
                node = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
                break;
            case 'base64image':
                node = document.createElementNS('http://www.w3.org/2000/svg', 'image');
                break;
            case 'image':
                node = document.createElementNS('http://www.w3.org/2000/svg', 'image');
                break;
            default:
                console.warn('Node type ' + ctrl.type + ' not suported by SVG renderer');
        }

        if(node !== false){
            renderOutput.result = node;
            if(ctrl.parent && ctrl.parent.renderOutput && ctrl.parent.renderOutput.result){
                ctrl.parent.renderOutput.result.appendChild(node);
            }else{
                renderOutput.result = false;
                console.warn('Trying to add child to non existing parent');
                console.log(ctrl);
            }
        }
    
        ctrl.setRenderOutput(renderOutput);

    }

    setTransform(ctrl, transformation){

        let matrix = transformation.getTransformationMatrix();

        var m = matrix.m;
        var data = m[0][0] + ',' + m[1][0] + ',' + m[0][1] + ',' + m[1][1] + ',' 
            + m[0][2] + ',' + m[1][2];
        ctrl.renderOutput.result.setAttribute('transform', 'matrix(' + data + ')');

    }

    setStyle(ctrl, keys, value){
        let name = keys.slice(0,1)[0];
        
        if(typeof value == 'undefined' || value == null){
            if(ctrl.renderOutput.result.style[name] === undefined){
                return;
            }
            value = '';
        }
        ctrl.renderOutput.result.style[name] = value;
    }



}

export default SVGRenderer;